import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../context/authContext';
import Banner from '../../Banner';

function ProfileForm() {
    const { t } = useTranslation();
    const auth = useAuthContext();

    const [profile, setProfile] = useState();
    const [oldProdile, setOldProfile] = useState();
    const [disableProfileButton, setDisableProfileButton] = useState(false);
    const [disablePassButton, setDisablePassButton] = useState(true);
    const [sendingPass, setSendingPass] = useState(false);

    const [password, setPassword] = useState("");
    const [passwordMessage, setPasswordMessage] = useState("");

    const [message, setMessage] = useState({
        type: '',
        message: '',
        open: false,
    });

    const [input, setInput] = useState({
        password: '',
        confirmPassword: ''
    });

    const [passwordError, setPasswordError] = useState({
        password: '',
        confirmPassword: ''
    })


    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_MP_PROFILE}`, {

                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Authorization': `Bearer ${auth.getToken()}`
                    }
                });
                setProfile(response.data);
                setOldProfile(response.data);

            } catch (exception) {
                console.log(exception);
                setProfile({});
            }
        };
        fetchProfile();

    }, [auth]);


    const handleProfileSubmit = (event) => {
        event.preventDefault();
        setDisableProfileButton(true);


        if (profile.name === "" || profile.lastName === "" || profile.company === "" || profile.phone === "") {
            setMessage({ ...message, type: "warning", message: t("auth.noData"), open: true });
            setDisableProfileButton(false);
            return;
        }


        const fetchUpdateProfile = async () => {
            try {
                await axios.patch(`${process.env.REACT_APP_MP_PROFILE}`,
                    JSON.stringify(profile),
                    {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*',
                            'Authorization': `Bearer ${auth.getToken()}`
                        }
                    }).then(r => {
                        setDisableProfileButton(false);
                        if (r !== null) {
                            setOldProfile(r.data)
                            setMessage({ ...message, type: "success", message: t("account.profile.profileSuccess"), open: true });
                        }
                    }
                    ).catch(error => {
                        setMessage({ ...message, type: "error", message: t("account.profile.profileError"), open: true });
                        setDisableProfileButton(false)

                    });

            } catch (exception) {
                console.log(exception);
            }
        };
        fetchUpdateProfile();
    }

    const reinizaliteInputs = (e) => {
        setProfile(oldProdile)
    }

    const onFormInputChange = (e) => {
        let { value } = e.target
        if (value !== "") {
            cleanMessage();
        }
    }

    const cleanMessage = () => {
        setMessage({ ...message, type: "", message: "", open: false });
    }
    const setOpen = (value) => {
        setMessage({ ...message, open: value });

    }

    const onInputChange = e => {
        const { name, value } = e.target;
        setInput(prev => ({
            ...prev,
            [name]: value
        }));
        validateInput(e);
    }


    const validateInput = e => {
        let { name, value } = e.target;
        cleanMessage();

        setPasswordError(prev => {
            const stateObj = { ...prev, [name]: "" };
            setDisablePassButton(true);

            switch (name) {

                case "password":
                    if (!value) {
                        stateObj[name] = t("auth.passwordEmpty");
                    } else if (value.length < 8) {
                        stateObj[name] = t("auth.passwordLength");
                    } else if (input.confirmPassword && value !== input.confirmPassword) {
                        stateObj[name] = t("auth.passwordNOtMatch");
                    } else {
                        stateObj[name] = input.confirmPassword ? "" : passwordError.confirmPassword;
                    }
                    break;

                case "confirmPassword":
                    if (!value) {
                        stateObj[name] = t("auth.passwordRepeatEmpty");
                    } else if (input.password && value !== input.password) {
                        stateObj[name] = t("auth.passwordNOtMatch");
                    } else {
                        stateObj[name] = "";
                        setPassword(input.password);
                        setDisablePassButton(false);
                    }
                    break;

                default:
                    break;
            }
            setPasswordMessage(stateObj[name]);


            return stateObj;
        });
    }

    const resetPassword = (event) => {
        event.preventDefault();
        setSendingPass(true)
        const fetchUpdatePassword = async () => {

            try {
                await axios.patch(`${process.env.REACT_APP_MP_UPDATE_PASSWOPRD}`,
                    password,
                    {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Access-Control-Allow-Origin': '*',
                            'Authorization': `Bearer ${auth.getToken()}`
                        }
                    }).then(r => {
                        setSendingPass(false)
                        setDisablePassButton(true);
                        if (r !== null) {
                            setMessage({ ...message, type: "success", message: t("account.profile.passwordSuccess"), open: true });
                        }
                    }
                    ).catch(error => {
                        setMessage({ ...message, type: "error", message: t("account.profile.passwordError"), open: true });
                        setDisableProfileButton(true)
                        setSendingPass(false)
                    });

            } catch (exception) {
                console.log(exception);
            }
        };
        fetchUpdatePassword();
    }















    return (<div className="grow ">
        {/* Panel body */}

        <div className="p-6 space-y-6">
            <Banner type={message.type} children={message.message} open={message.open} setOpen={setOpen} className="mb-3 w-ful"></Banner>

            <h2 className="text-2xl text-airco2-sidebar mb-5">{t("account.profile.myprofile")}</h2>


            {profile === undefined && <div className="text-center">
                <div className="spinner-border animate-spin inline-block w-12 h-12 border-4 rounded-full text-airco2-principal" role="status">
                    <span className="visually-hidden">{t("account.orders.getOrders")}</span>
                </div>
                <div>
                    {t("account.profile.getData")}
                </div>
            </div>}


            {profile !== undefined &&
                <section>

                    <h2 className="text-xl leading-snug text-airco2-sidebar mb-1">  {t("account.profile.data")} </h2>

                    <form onSubmit={handleProfileSubmit}>
                        <div className="sm:flex sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mt-4">
                            <div className="sm:w-1/3">
                                <label className="block text-airco2-general mb-1" htmlFor="name">{t("account.profile.name")}</label>
                                <input id="name" className="form-user-data text-airco2-general  w-full" type="text" required
                                    value={profile.name}
                                    onChange={event => setProfile((prevState) => ({
                                        ...prevState,
                                        name: event.target.value
                                    }))}
                                    onKeyUp={(e) => onFormInputChange(e)} />
                            </div>

                            <div className="sm:w-1/3">
                                <label className="block text-airco2-general mb-1" htmlFor="sector">{t("account.profile.lastName")}</label>
                                <input id="sector" className="form-user-data text-airco2-general  w-full" type="text" required
                                    value={profile.lastName}
                                    onChange={event => setProfile((prevState) => ({
                                        ...prevState,
                                        lastName: event.target.value
                                    }))}
                                    onKeyUp={(e) => onFormInputChange(e)} />
                            </div>

                            <div className="sm:w-1/3">
                                <label className="block text-airco2-general mb-1" htmlFor="companyName">{t("account.profile.company")}</label>
                                <input id="companyName" className="form-user-data text-airco2-general  w-full" type="text" required
                                    value={profile.company}
                                    onChange={event => setProfile((prevState) => ({
                                        ...prevState,
                                        company: event.target.value
                                    }))}
                                    onKeyUp={(e) => onFormInputChange(e)} />
                            </div>


                            <div className="sm:w-1/3">
                                <label className="block text-airco2-general mb-1" htmlFor="phone">{t("account.profile.phone")}</label>
                                <input id="phone" className="form-user-data text-airco2-general  w-full" type="tel" pattern="[0-9]{3}[0-9]{3}[0-9]{3}" required

                                    value={profile.phone}
                                    onChange={event => setProfile((prevState) => ({
                                        ...prevState,
                                        phone: event.target.value
                                    }))}
                                    onKeyUp={(e) => onFormInputChange(e)} />
                            </div>
                        </div>

                        <div className="pt-4">
                            <div className="flex flex-col  md:flex-row gap-3 justify-end">
                                <button arial-label="btn-reinizalite" className="btn  bg-airco2-general text-white"
                                    type='reset' onClick={(e) => reinizaliteInputs()}>{t("account.profile.cancel")}</button>

<button className="btn bg-airco2-principal text-white " type="submit" disabled={disableProfileButton}>

                                    {disableProfileButton ? <svg role="status" className="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                                    </svg> : t("account.profile.saveProfile")}
                                </button>
                            </div>
                        </div>
                    </form>
                </section>
            }
            {/* Password */}
            <section>
                <h2 className="text-xl leading-snug text-airco2-sidebar">{t("account.profile.updatePassword")}</h2>
                <form onSubmit={resetPassword}>
                    <div className="sm:flex sm:items-center space-y-4 sm:space-y-0 sm:space-x-4 mt-4 mb-1">

                        <div className="sm:w-1/3">
                            <label className="block text-airco2-general mb-1" htmlFor="business-id">{t("account.profile.password")}</label>
                            <input id="password" className="form-user-data text-airco2-general  w-full" name="password" type="password"
                                autoComplete='on'
                                defaultValue={password}
                                onChange={(e) => onInputChange(e)}
                                onBlur={(e) => validateInput(e)} />
                        </div>
                        <div className="sm:w-1/3">
                            <label className="block text-airco2-general mb-1" htmlFor="location">{t("account.profile.repeatPassword")}</label>
                            <input id="seconfirmPasswordctor" className="form-user-data text-airco2-general  w-full" name="confirmPassword" type="password"
                                autoComplete='on'
                                defaultValue={password}
                                onChange={(e) => onInputChange(e)}
                                onBlur={(e) => validateInput(e)} />
                        </div>

                    </div>
                    {passwordMessage !== "" && <p className="mt-2 text-xs text-airco2-secondary dark:text-green-400"><span className="font-medium"> {passwordMessage} </span> </p>}


                    <div className="flex flex-col pt-4 ">
                        <div className="flex self-end">

                            <button className="btn bg-airco2-principal ml-3 text-white" type="submit" disabled={disablePassButton}>
                                {sendingPass ? <svg role="status" className="inline mr-3 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                                </svg> : t("account.profile.updatePassword")}
                            </button>
                        </div>
                    </div>
                </form>
            </section>

        </div>

    </div>)
}

export default ProfileForm;